import mapKeys from 'lodash/mapKeys'
import snakeCase from 'lodash/snakeCase'

export function responseAsJSON(response) {
  if (response.ok) {
    return response.json()
  } else {
    const err = new Error(`HTTP ${response.status}`)
    err.response = response

    return Promise.reject(err)
  }
}

export function keysToSnakeCase(data) {
  return mapKeys(data, (_v, k) => snakeCase(k))
}

export function encodeAsJSON(data) {
  return JSON.stringify(keysToSnakeCase(data))
}
